import graphqlClient from '@plugins/graphql';
import graphqlClientUload from '@plugins/graphqlupload';
import graphQuery from '../../../graphql/klaim';
import { getDeepObj } from '../../../utils/format';

export const state = {
  data: null,
  instansis: null,
  masters: null,
};

export const mutations = {
  SET_DATA(state, newValue) {
    state.data = newValue;
  },
  SET_INSTANSI(state, newValue) {
    state.instansis = newValue;
  },
  SET_MASTERS(state, newValue) {
    state.masters = newValue;
  },
};

export const actions = {
  async fetch({ rootState }, payload) {
    rootState.loading = true;
    const resp = await graphqlClient.query({
      query: graphQuery['LIST'],
      variables: {
        page: payload.params.page,
        keyword: getDeepObj(payload, 'params.filter.keyword') || '',
      },
      fetchPolicy: 'network-only',
    });

    rootState.loading = false;
    return Promise.resolve((resp && resp.data) || {});
  },

  async getInstansi({ rootState, commit }) {
    rootState.loading = true;
    const resp = await graphqlClient.query({
      query: graphQuery['INSTANSI'],
      variables: {
        fetchPolicy: 'network-only',
      },
    });

    const items = (resp && resp.data && resp.data.ptkLpdList && resp.data.ptkLpdList.data) || [];
    let temp = [];
    items.forEach((item) => {
      temp.push({ value: item.instansi_id, text: item.instansi.nama });
    });
    rootState.loading = false;
    commit('SET_INSTANSI', temp);
    return Promise.resolve((resp && resp.data) || {});
  },

  async getDetail({ rootState }, payload) {
    rootState.loading = true;
    const resp = await graphqlClient.query({
      query: graphQuery['DETAIL'],
      variables: payload,
      fetchPolicy: 'network-only',
    });

    rootState.loading = false;
    return Promise.resolve((resp && resp.data) || {});
  },

  async getMasters({ rootState, commit }) {
    rootState.loading = true;
    const resp = await graphqlClient.query({
      query: graphQuery['MASTERS'],
      variables: {
        fetchPolicy: 'network-only',
      },
    });

    const items = (resp && resp.data) || [];
    let temp = {};
    Object.keys(items).forEach((key) => {
      let item = items[key].map((i) => {
        return {
          value: Number(i.key),
          text: i.value,
        };
      });

      temp[key] = item;
    });
    rootState.loading = false;
    commit('SET_MASTERS', temp || {});
    return Promise.resolve((resp && resp.data) || {});
  },

  async createDiklat({ rootState }, payload) {
    rootState.loading = true;
    try {
      const resp = await graphqlClientUload.mutate({
        mutation: graphQuery['CREATE'],
        variables: payload,
      });

      const { data } = resp;
      rootState.loading = false;
      return Promise.resolve(data ?? null);
    } catch ({ graphQLErrors, networkError, message }) {
      // error handler
      rootState.loading = false;
      return Promise.reject(message);
    }
  },

  async updateDiklat({ rootState }, payload) {
    rootState.loading = true;
    try {
      const resp = await graphqlClientUload.mutate({
        mutation: graphQuery['UPDATE'],
        variables: payload,
      });

      const { data } = resp;
      rootState.loading = false;
      return Promise.resolve(data ?? null);
    } catch ({ graphQLErrors, networkError, message }) {
      // error handler
      rootState.loading = false;
      return Promise.reject(message);
    }
  },

  async deleteDiklat({ rootState }, payload) {
    rootState.loading = true;
    try {
      const resp = await graphqlClientUload.mutate({
        mutation: graphQuery['DELETE'],
        variables: payload,
      });

      const { data } = resp;
      rootState.loading = false;
      return Promise.resolve(data ?? null);
    } catch ({ graphQLErrors, networkError, message }) {
      // error handler
      rootState.loading = false;
      return Promise.reject(message);
    }
  },

  async ajuanDiklat({ rootState }, payload) {
    rootState.loading = true;
    try {
      const resp = await graphqlClientUload.mutate({
        mutation: graphQuery['SUBMIT'],
        variables: payload,
      });

      const { data } = resp;
      rootState.loading = false;
      return Promise.resolve(data ?? null);
    } catch ({ graphQLErrors, networkError, message }) {
      // error handler
      rootState.loading = false;
      return Promise.reject(message);
    }
  },

  async batalAjuanDiklat({ rootState }, payload) {
    rootState.loading = true;
    try {
      const resp = await graphqlClientUload.mutate({
        mutation: graphQuery['RESET'],
        variables: payload,
      });

      const { data } = resp;
      rootState.loading = false;
      return Promise.resolve(data ?? null);
    } catch ({ graphQLErrors, networkError, message }) {
      // error handler
      rootState.loading = false;
      return Promise.reject(message);
    }
  },
};
